import {useCallback, useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';

import { getActivity } from '../../utils/api';

import Header from '../header/Header';
import Pathway from '../pathway/Pathway';
import Transcript from '../transcript/Transcript';

import './Activity.css';

function Activity({ handleConfetti, handleError, handleFeedback, handlePath, handleStartOver }) {
  const { activityId } = useParams();

  const [activity, setActivity] = useState(null);

  const loadActivity = useCallback(async (id) => {
    try {
      setActivity(await getActivity(id));
    } catch (e) {
      handleError(e);
    }
  }, [handleError]);

  useEffect(() => {
    loadActivity(activityId);
  }, [activityId, loadActivity]);

  return (
    <>
      <Header activeElement="path" handleFeedback={handleFeedback} handlePath={handlePath} handleStartOver={handleStartOver} />
      <div id="activity" className="clamp">
        <Pathway activityId={activityId} handleError={handleError} />
        <Transcript activity={activity} handleConfetti={handleConfetti} handleError={handleError} handlePath={handlePath} isProfile={false} transcript={activity?.messages} />
      </div>
    </>
  );
}

export default Activity;
